// Port of frontend/src/lib/mapTripTypes.ts.
export const MAP_TRIP_TYPES = [
  { id: 'day_trip', label: 'Day trip', maxMinutes: 150 },
  { id: 'short_trip', label: 'Short trip', maxMinutes: 210 },
  { id: 'overnight', label: 'Overnight', maxMinutes: 270 },
  { id: 'weekend', label: 'Weekend', maxMinutes: 300 },
];

export function parseFlightMinutes(flightTime) {
  const hours = flightTime.match(/(\d+)\s*h/);
  const minutes = flightTime.match(/(\d+)\s*min/);
  return (hours ? Number(hours[1]) * 60 : 0) + (minutes ? Number(minutes[1]) : 0);
}

export function destinationMatchesTripTypes(dest, activeTypes) {
  if (activeTypes.size === 0) return true;
  const minutes = parseFlightMinutes(dest.flightTime);
  return MAP_TRIP_TYPES.some((type) => activeTypes.has(type.id) && minutes <= type.maxMinutes);
}

export function filterDestinationsByTripTypes(destinations, activeTypes) {
  return destinations.filter((dest) => destinationMatchesTripTypes(dest, activeTypes));
}

export function tripTypeToSearchParam(activeTypes) {
  if (activeTypes.has('weekend')) return 'long_weekend';
  if (activeTypes.has('overnight')) return 'overnight';
  if (activeTypes.has('short_trip')) return 'overnight';
  if (activeTypes.has('day_trip')) return 'day_trip';
  return 'day_trip';
}

export function countryFlagEmoji(code) {
  if (!code || code.length !== 2) return '🌍';
  return [...code.toUpperCase()].map((c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65)).join('');
}
